import { FC, useEffect, useRef } from 'react';

import usePreviewDocumentInstance from '@/api/queries/documentTemplates/usePreviewDocumentInstance';
import useSearchParamState from '@/hooks/useSearchParamState';
import { useFirstMountState } from '@payaca/hooks';
import { Prompt, useHistory } from 'react-router';
import { CreateDocumentInstanceForm } from '../components/createDocumentInstanceForm/CreateDocumentInstanceForm';
import AuthenticatedPageWrapper from './pageWrappers/authenticatedPageWrapper/AuthenticatedPageWrapper';

export const PreviewDocumentInstancePage: FC<{
  templateId: string;
  projectId: string;
}> = (props) => {
  const { templateId, projectId } = props;
  const history = useHistory();

  const isFirstMount = useFirstMountState();
  const suppressPromptRef = useRef(false);

  const { documentHtml, documentTemplate, error } = usePreviewDocumentInstance({
    templateId,
    projectId,
  });

  const [folderId, setFolderId] = useSearchParamState('folderId', '');

  useEffect(() => {
    if (error) {
      history.goBack();
    }
    // oxlint-disable-next-line eslint-plugin-react-hooks(exhaustive-deps) -- FIXME: pre-existing error: React Hook useEffect has a missing dependency: 'history'
  }, [error]);

  const onSuccess = () => {
    suppressPromptRef.current = true;
    // Take the user back to the project 'files' tab so they can look at their nice new document
    history.push(`/projects/${projectId}/files`);
  };

  return (
    <>
      <AuthenticatedPageWrapper
        scrollLock
        breadcrumbItems={[
          { label: 'Back', to: `/projects/${projectId}/files` },
          { label: 'Preview Document' },
        ]}
      >
        <Prompt
          when={!isFirstMount && !suppressPromptRef.current}
          message={() => {
            if (isFirstMount || suppressPromptRef.current) return true;
            return "You haven't generated the document yet. Are you sure you want to leave this page?";
          }}
        />
        {documentTemplate && documentHtml && (
          <CreateDocumentInstanceForm
            templateId={templateId}
            projectId={projectId}
            folderId={folderId?.length ? folderId : undefined}
            templatePreviewHtml={documentHtml}
            defaultValues={{
              name: documentTemplate.name,
            }}
            onSuccess={onSuccess}
          />
        )}
      </AuthenticatedPageWrapper>
    </>
  );
};
